import React from 'react';
import _ from 'underscore';

type UseScrollListener = {
	ref: React.RefObject<HTMLElement>;
	onScroll(el: HTMLElement): void;
};

export default function useScrollListener({ref, onScroll}: UseScrollListener) {
	React.useEffect(() => {
		if (!ref.current) return;
		const scrollListener = _.throttle(
			() => {
				if (!ref.current) return;
				onScroll(ref.current);
			},
			16,
			{trailing: true},
		);

		ref.current.addEventListener('scroll', scrollListener, true);
		return () => {
			ref.current?.removeEventListener('scroll', scrollListener, true);
		};
	}, [ref, onScroll]);
}
